<template>
  <div class="c-app">

    <div class="wraper">
        <TheHeader/>

        <TheSidebar/>
        <LoadingPage/>


        <main class="main">
            <div class="container-fluid">
                <router-view v-slot="{ Component, route }">
                    <transition name="fade" mode="out-in">
                        <div :key="route.name">
                            <component :is="Component"></component>
                        </div>
                    </transition>
                </router-view>


            </div>
        </main>


    </div>


  </div>
</template>

<script>

import TheHeader from './TheHeader'
import TheSidebar from './TheSidebar'
import LoadingPage from "./LoadingPage";
export default {
  name: 'TheContainer',
  props: {},
  data() {
    return {
      theme_mode_parent: '',
      mybutton: '',
    }
  }, components: {

    TheHeader,
    TheSidebar,
    LoadingPage,
  }, beforeCreate() {
    // this.fetch_config()
  }
  , methods: {


  },
  mounted() {

  },

}
</script>
